/* eslint-disable no-console */
import { DEV } from 'application/consts';

export type TLogUtils = {
  debug: (message: string, ...args: any[]) => false | void;
  info: (message: string, ...args: any[]) => false | void;
  warn: (message: string, ...args: any[]) => false | void;
  error: (message: string, error?: any) => void;
};

export const LogUtils = {
  debug: (message: string, ...args: any[]) => DEV && console.debug(`🔍 ${message}`, ...args),

  info: (message: string, ...args: any[]) => DEV && console.info(`ℹ️ ${message}`, ...args),

  warn: (message: string, ...args: any[]) => DEV && console.warn(`⚠️ ${message}`, ...args),

  error: (message: string, error?: any, context?: string) => {
    const prefix = context ? `[${context}] ` : '';

    if (DEV) {
      console.error(`❌ ${prefix}${message}`, error || '');
    } else {
      console.error(`Error: ${prefix}${message}`);
    }
  },

  group: (label: string, callback: () => void) => {
    if (!DEV) return;

    console.group(label);
    callback();
    console.groupEnd();
  },

  component: {
    mount: (name: string) => DEV && console.log(`🚀 ${name} mounted`),
    unmount: (name: string) => DEV && console.log(`👋 ${name} unmounted`),
    update: (name: string, props: any) => DEV && console.log(`🔄 ${name} updated`, props),
  },

  effect: (name: string, deps: any[]) => {
    if (!DEV) return;

    console.group(`🎬 ${name} effect`);
    console.log('Dependencies:', deps);
    console.groupEnd();
  },

  query: {
    start: (queryName: string, variables?: any) => DEV && console.log(`📤 ${queryName} start`, variables || ''),
    success: (queryName: string, data: any) => DEV && console.log(`✅ ${queryName} success`, data),
    error: (queryName: string, error: any) => console.error(`❌ ${queryName} error`, error),
  },
};

export const createLogger = (context: string): TLogUtils => ({
  debug: (message: string, ...args: any[]) => LogUtils.debug(`[${context}] ${message}`, ...args),
  info: (message: string, ...args: any[]) => LogUtils.info(`[${context}] ${message}`, ...args),
  warn: (message: string, ...args: any[]) => LogUtils.warn(`[${context}] ${message}`, ...args),
  error: (message: string, error?: any) => LogUtils.error(message, error, context),
});
